import { PrimeMemberByPublicId } from 'iam/MemberStore'
import Member from 'iam/models/Member'
import { Model } from 'infra/model'
import { observable, makeObservable } from 'mobx'
import { ParticipantDTO, ParticipantType } from '../dtos/messages'
import Conversation from './Conversation'

export class Participant extends Model<ParticipantDTO, Participant> {
  type: ParticipantType = 'MEMBER'
  @observable member = Member.none
  @observable active = false
  @observable online = false
  @observable lastSeen: Date | null = null
  @observable muted = false

  constructor(
    public conversation: Conversation,
    private primeMember: PrimeMemberByPublicId,
  ) {
    super()
    makeObservable(this)
  }

  parse(attrs: Partial<ParticipantDTO>): Partial<Participant> {
    const member = this.primeMember({
      workspace_id: this.conversation.workspace.id,
      user_id: attrs.user_id,
      user_public_id: attrs.user_public_id,
    })
    return {
      member,
      type: attrs.type,
      active: attrs.active,
      lastSeen: attrs.last_seen,
      online: attrs.online,
      muted: attrs.muted,
    }
  }
}
